export default __webpack_public_path__ + "static/media/paik_yang.df913ca9.png";